export var eventProduct = function eventProduct(_config, _data, globalConfig) {
  return {
    'event:product': "".concat(globalConfig.product)
  };
};